'use client';

import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import AppImage from '@/components/ui/AppImage';

interface HeaderProps {
  className?: string;
}

const Header = ({ className = '' }: HeaderProps) => {
  return (
    <header
      className={`relative top-0 left-0 right-0 z-50  ${className}`}
    >
      <div className="w-full">
        <div className="flex items-center justify-center ">
          {/* Logo Section */}
          <Link href="/homepage" className="flex items-center group">
            <div className="relative ">
              <div className="absolute inset-0 bg-frost-blue opacity-20 blur-lg group-hover:opacity-40 transition-opacity duration-300"></div>
              <AppImage
                src="/assets/images/ChatGPT_Image_Jan_9_2026_04_25_36_PM-1767978494282.png"
                alt="OnlyFabbz Logo"
                width={384}
                height={256}
                className="relative z-10 rounded-lg object-contain"
              />
            </div>
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;